module.exports = __webpack_public_path__ + "static/img/S50_bg.12c1cdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/S50_bg.jpg
// module id = tBGW
// module chunks = 0